<!-- 入力画面ダイアログ -->
<p-dialog [header]="title" [(visible)]="inputModal" [modal]="true" [resizable]="false">
  <!-- 入力情報 -->
  <app-generate-input-information
    (reloadID)="return($event)"
    (closeModal)="onCloseClick()"
  ></app-generate-input-information>
</p-dialog>
